import React from "react";
import "./loader.css";

import { useTheme } from "../../../contexts/ThemeContext";

import PulseLoader from "react-spinners/PulseLoader";

export default function Loader({ loading, style, small, dark }) {
  const { theme } = useTheme();
  return (
    <div
      className="loading-container"
      style={style ? style : { display: "flex" }}
    >
      <PulseLoader
        loading={loading}
        color={theme === "dark" && !dark ? "#fff" : "#151515"}
        speedMultiplier="0.75"
        size={small ? "8px" : "15px"}
      />
    </div>
  );
}
